import { ReactElement, useEffect } from 'react';
import { useFormikContext } from 'formik';
import ContactInformation from '@components/ContactInformation/ContactInformation';
import { courtContactInfoDisplayObject } from '@services/FormFieldConfig';
import { iCourtFormValues } from '@services/CourtService';

function CourtStep5(): ReactElement {
  const context = useFormikContext();
  const { values }: { values: iCourtFormValues } = useFormikContext();
  const { TitleMrMrsMsMissOther, PartialFormID } = values;

  useEffect(() => {
    if (PartialFormID) {
      if (!TitleMrMrsMsMissOther) {
        context.setFieldValue('TitleMrMrsMsMissOther', values.FormData.user.title.toUpperCase());
        context.setFieldTouched('TitleMrMrsMsMissOther');
      }
      context.setFieldValue('GivenNames', values.FormData.user.givenName);
      context.setFieldValue('FamilyName', values.FormData.user.familyName);
      if (values.FormData.user.licence.number) context.setFieldValue('DRIVER_LICENCE', values.FormData.user.licence.number);
      else context.setFieldValue('DRIVER_LICENCE', values.DRIVER_LICENCE);
      if (values.FormData.user.licence.country === '') context.setFieldValue('StatecountryOfIssue', 'Australia');
      else context.setFieldValue('StatecountryOfIssue', values.FormData.user.licence.country);
      context.setFieldValue('LicenceState', values.FormData.user.licence.state);
      if (values.FormData.user.dateOfBirth.day === '' || values.FormData.user.dateOfBirth.month === '' || values.FormData.user.dateOfBirth.year === '') {
        context.setFieldValue('DOB', null);
      } else context.setFieldValue('DOB', new Date(`${values.FormData.user.dateOfBirth.month}/${values.FormData.user.dateOfBirth.day}/${values.FormData.user.dateOfBirth.year}`));
      context.setFieldValue('HasDifferentResidentialAddress', values.FormData.user.residentialAddress.hasDifferentResidentialAddress.toString());
      context.setFieldValue('ResidentialAddress.LineOne', values.FormData.user.residentialAddress.line1);
      context.setFieldValue('ResidentialAddress.LineTwo', values.FormData.user.residentialAddress.line2);
      context.setFieldValue('ResidentialAddress.Suburb', values.FormData.user.residentialAddress.suburb);
      context.setFieldValue('ResidentialAddress.State', values.FormData.user.residentialAddress.state);
      context.setFieldValue('ResidentialAddress.Postcode', values.FormData.user.residentialAddress.postcode);
      if (values.FormData.user.residentialAddress.country === '') context.setFieldValue('ResidentialAddress.Country', 'Australia');
      else context.setFieldValue('ResidentialAddress.Country', values.FormData.user.postalAddress.country);
      context.setFieldValue('CourtContactNumber.ContactNumber', values.FormData.user.primaryContact.number);
      context.setFieldValue('CourtContactNumber.NumberType', values.FormData.user.primaryContact.type);
      context.setFieldValue('CourtContactNumber.SecondaryContactNumber', values.FormData.user.secondaryContact.number);
      context.setFieldValue('CourtContactNumber.SecondaryNumberType', values.FormData.user.secondaryContact.type);
      if (values.FormData.user.email === null) context.setFieldValue('Email', '');
      else context.setFieldValue('Email', values.FormData.user.email);
      context.setFieldValue('EMAIL_TO', values.FormData.sendcopy !== undefined ? `${values.FormData.sendcopy}` : '');
    }
  }, [TitleMrMrsMsMissOther]);

  return (
    <>
      <ContactInformation displayObject={courtContactInfoDisplayObject} currentStep="Select if you do not have an email address" />
    </>
  );
}
export default CourtStep5;
